import React from "react";
import { LoginComponent } from "./components/index";
import "../../assets/styles/css/index.css";

const Login = () => {
  return <LoginComponent  />;
};

export default Login;
